import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const PublicRoute = ({ component: Component, ...rest }) => {
  const isAuthenticated = () => {
    return !!localStorage.getItem('accessToken');
  };

  const isRegistrationRoute = rest.path && rest.path.includes('/registration/');

  return (
    <Route
      {...rest}
      render={(props) => {
        if (isRegistrationRoute) {
          return <Component {...props} />;
        }
        
        return isAuthenticated() ? (
          <Redirect to="/app" />
        ) : (
          <Component {...props} />
        );
      }}
    />
  );
};

export default PublicRoute;